export const paths = {
  SERVICEPOINT_DETAIL: ':spId',
}

export const servicepointsLinks = {
  servicepointDetailLink: (params: { spId: string }) => `/${params.spId}`,
}

export type ServicepointsLinks = typeof servicepointsLinks
